// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.selector_wrapper_aI_Ba {
    width: 150px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: var(--ui-tertiary);
}

.selector_new-buttons_v7TtN {
    position: absolute;
    bottom: 0;
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 0.75rem 0;
    color: var(--looks-secondary);
    text-align: center;
    background: none;
}

.selector_new-buttons_v7TtN:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right:0;
    width: 100%;
    pointer-events: none;
}

.selector_new-buttons_v7TtN > button + button {
    margin-top: 0.75rem;
}

.selector_list-area_eDXQ7 {
    /* Must have some height (recalculated by flex-grow) in order to scroll */
    height: 0;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
}

.selector_list-area_eDXQ7:after {
    /* Make sure there is room to scroll beyond the last tile */
    content: '';
    display: block;
    height: 70px;
    width: 100%;
    flex-shrink: 0;
    order: 99999999;
}

.selector_list-item_jEFRz {
    width: 5rem;
    height: 5rem;
    margin: 0.5rem auto;
}

@media only screen and (max-width: 1249px) {
    .selector_wrapper_aI_Ba {
        width: 80px;
    }

    .selector_list-item_jEFRz {
        width: 4rem;
    }
}

.selector_list-item_jEFRz.selector_placeholder_wf5MS {
    background: white;
    filter: opacity(15%) brightness(0%);
}
`, "",{"version":3,"sources":["webpack://./src/components/asset-panel/selector.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;;IAEX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,OAAO;IACP,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yEAAyE;IACzE,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2DAA2D;IAC3D,WAAW;IACX,cAAc;IACd,YAAY;IACZ,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;AACvC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.wrapper {\n    width: 150px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: var(--ui-tertiary);\n}\n\n.new-buttons {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n    padding: 0.75rem 0;\n    color: var(--looks-secondary);\n    text-align: center;\n    background: none;\n}\n\n.new-buttons:before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right:0;\n    width: 100%;\n    pointer-events: none;\n}\n\n.new-buttons > button + button {\n    margin-top: 0.75rem;\n}\n\n.list-area {\n    /* Must have some height (recalculated by flex-grow) in order to scroll */\n    height: 0;\n    flex-grow: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.list-area:after {\n    /* Make sure there is room to scroll beyond the last tile */\n    content: '';\n    display: block;\n    height: 70px;\n    width: 100%;\n    flex-shrink: 0;\n    order: 99999999;\n}\n\n.list-item {\n    width: 5rem;\n    height: 5rem;\n    margin: 0.5rem auto;\n}\n\n@media only screen and (max-width: 1249px) {\n    .wrapper {\n        width: 80px;\n    }\n\n    .list-item {\n        width: 4rem;\n    }\n}\n\n.list-item.placeholder {\n    background: white;\n    filter: opacity(15%) brightness(0%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `selector_wrapper_aI_Ba`,
	"new-buttons": `selector_new-buttons_v7TtN`,
	"newButtons": `selector_new-buttons_v7TtN`,
	"list-area": `selector_list-area_eDXQ7`,
	"listArea": `selector_list-area_eDXQ7`,
	"list-item": `selector_list-item_jEFRz`,
	"listItem": `selector_list-item_jEFRz`,
	"placeholder": `selector_placeholder_wf5MS`
};
export default ___CSS_LOADER_EXPORT___;
